module.exports = __webpack_public_path__ + "img/slider1.b28db925.png";